export const getTasks = async (authToken: string) => {
  const response = await fetch(
    `${import.meta.env.VITE_CORE_API_URL}/tasks/all`,
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authToken}`,
      },
      method: "GET",
    }
  )

  const { data } = await response.json()

  if (response.ok) {
    const tasks = data
    if (tasks) return tasks
  }
}
